module.exports = __webpack_public_path__ + "omniv2/img/icon-play-store.8ca20b0f.svg";